const authParsed = authSchema.safeParse(auth);

export function useAuth() {
  if (!authParsed.success) {
    throw new Error("Auth data is invalid");
  }
  return { auth: authParsed.data };
}
